document.addEventListener('readystatechange', () => {
    if (document.readyState !== 'complete') return;

    const searchField = document.getElementById('searchFormField');
    if (searchField) {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('search')) {
            searchField.value = urlParams.get('search');
        }
    }
});
